import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-copy.tsx
/**
* icon.24.copy
*
* Keywords: duplicate, layers, multiple, stacked, rectangles, offset, clone, overlapping
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy41IDZBMS41IDEuNSAwIDAgMCA2IDcuNXY2QTEuNSAxLjUgMCAwIDAgNy41IDE1aDZhMS41IDEuNSAwIDAgMCAxLjUtMS41di02QTEuNSAxLjUgMCAwIDAgMTMuNSA2ek03IDcuNWEuNS41IDAgMCAxIC41LS41aDZhLjUuNSAwIDAgMSAuNS41djZhLjUuNSAwIDAgMS0uNS41aC02YS41LjUgMCAwIDEtLjUtLjV6bTIgOWEuNS41IDAgMCAxIDEgMCAuNS41IDAgMCAwIC41LjVoNmEuNS41IDAgMCAwIC41LS41di02YS41LjUgMCAwIDAtLjUtLjUuNS41IDAgMCAxIDAtMSAxLjUgMS41IDAgMCAxIDEuNSAxLjV2NmExLjUgMS41IDAgMCAxLTEuNSAxLjVoLTZBMS41IDEuNSAwIDAgMSA5IDE2LjUiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2325
*/
const Icon24Copy = memo(function Icon24Copy(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M7.5 6A1.5 1.5 0 0 0 6 7.5v6A1.5 1.5 0 0 0 7.5 15h6a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 13.5 6zM7 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5zm2 9a.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5.5.5 0 0 1 0-1 1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 9 16.5",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Copy };

//# sourceMappingURL=icon-24-copy.js.map